import {
    Card,
    Modal,
    ModalBody,
    ModalContent, ModalFooter,
    ModalHeader,
    Select,
    SelectItem,
    Table, TableBody, TableCell, TableColumn,
    TableHeader, TableRow
} from '@nextui-org/react'
import RootAdmin from "../../../../components/layouts/RootAdmin";
import React, { useState, useEffect } from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFetcher } from '../../../../services/api';
import useSWR from "swr";

// Mapbox melempar galat pada koordinat kosong atau di luar rentang, dan galat itu
// menjatuhkan seluruh halaman - bukan hanya penanda yang bersangkutan.
const koordinatSah = (lat, lon) => {
    // Number(null) dan Number('') = 0, jadi nilai kosong harus ditolak lebih dulu
    if (lat == null || lon == null || lat === '' || lon === '') return false;
    const y = Number(lat);
    const x = Number(lon);
    return Number.isFinite(y) && Number.isFinite(x) && Math.abs(y) <= 90 && Math.abs(x) <= 180;
};

const ImportMaps = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tipe, setTipe] = useState('sebaran-perusahaan')
    const [viewport, setViewport] = useState({
        latitude: -1.3911261987874894,
        longitude: 113.4216565328876,
        zoom: 5,
    });

    const { data: map, mutate: mutateMap } = useSWR(
        `/api/dashboard/pelaporan/import/peta/${tipe}`,
        getFetcher
    );
    console.log(map, 'isi map')
  const [selectedPoint, setSelectedPoint] = useState(null);

  const handleViewportChange = (newViewport) => {
    setViewport(newViewport);
  };

  function titlePage(data) {
      switch (data) {
          case 'sebaran-perusahaan':
              return 'Peta Sebaran Perusahaan Import';
          case 'sebaran-bahanb3':
              return 'Peta Sebaran Bahan B3 Import';
          case 'sebaran-perusahaan-melaporkan':
              return 'Peta Sebaran Perusahaan Melapor Import';
          case 'sebaran-pelabuhan-bongkar':
              return 'Peta Sebaran Pelabuhan Bongkar Import';
          case 'sebaran-gudang':
              return 'Peta sebaran-gudang import';
            case 'sebaran-bahanb3-province':
              return 'Peta Sebaran B3 Provinsi';
          case 'sebaran-bahanb3-regencies':
              return 'Peta Sebaran B3 Kabupaten';
          default:
              return ''
      }
  }

  function renderPopup(data) {
      switch (data) {
          case 'sebaran-perusahaan':
          case 'sebaran-perusahaan-melaporkan':
              return (
                  <Popup
                      latitude={selectedPoint.latitude}
                      longitude={selectedPoint.longitude}
                      onClose={() => setSelectedPoint(null)} // Close popup
                      closeButton={true}
                      closeOnClick={false}
                  >
                      <div>
                          <h3>{selectedPoint.name}</h3>
                          <p>{selectedPoint.alamatKantor}</p>
                          <p><strong>Coordinates:</strong> {selectedPoint.latitude}, {selectedPoint.longitude}</p>
                          {selectedPoint.penanggungJawab && <p>
                              <strong>{selectedPoint.penanggungJawab}</strong> {selectedPoint.emailKantor}, {selectedPoint.telpKantor}
                          </p>}
                          {data === 'sebaran-perusahaan-melaporkan' && <p><strong>Total Pelaporan:</strong> {selectedPoint.count}</p>}
                      </div>
                  </Popup>
              )
          default:
              return ''
      }
  }

    function renderModal() {
        return (
            <Modal
                size="lg"
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                className={'bg-line'}
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">
                                {selectedPoint?.provinceName || selectedPoint?.namaPelabuhan || selectedPoint?.companyName}
                            </ModalHeader>
                            <ModalBody className={'flex flex-col gap-1'}>
                                <p>
                                    <strong>Coordinates:</strong> {selectedPoint.latitude}, {selectedPoint.longitude}
                                </p>
                                <div className="flex w-full justify-center">
                                    <Table aria-label="Example static collection table">
                                        <TableHeader>
                                            <TableColumn>Nama Bahan Kimia</TableColumn>
                                            <TableColumn>Nama Dagang</TableColumn>
                                            <TableColumn>Jumlah B3 di Impor (Kg)</TableColumn>
                                        </TableHeader>
                                        <TableBody>
                                            {selectedPoint?.bahanB3?.length >= 1 ? selectedPoint?.bahanB3?.map((b3, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{b3.namaBahanKimia}</TableCell>
                                                    <TableCell>{b3.namaDagang}</TableCell>
                                                    <TableCell>{b3.totalPembelian ?? 0}</TableCell>
                                                </TableRow>
                                            )) : (
                                                <TableRow key={0}>
                                                    <TableCell colSpan={3} style={{ textAlign: "center" }}>
                                                        No Data
                                                    </TableCell>
                                                    <TableCell className={'hidden'}/>
                                                    <TableCell className={'hidden'}/>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </ModalBody>
                            <ModalFooter/>
                        </>
                    )}
                </ModalContent>
            </Modal>
        )
    }

    const filtering = [
        {
            name: 'Sebaran Perusahaan',
            value: 'sebaran-perusahaan'
        },
        {
            name: 'Sebaran B3',
            value: 'sebaran-bahanb3'
        },
        {
            name: 'Sebaran Perusahaan Melaporkan',
            value: 'sebaran-perusahaan-melaporkan'
        },
         {
            name: 'Sebaran Pelabuhan Bongkar',
            value: 'sebaran-pelabuhan-bongkar'
        },
        {
            name: 'Sebaran Gudang',
            value: 'sebaran-gudang'
        },
        {
            name: 'Sebaran B3 Kabupaten',
            value: 'sebaran-bahanb3-regencies'
        },
        {
            name: 'Sebaran B3 Provinsi',
            value: 'sebaran-bahanb3-province'
        },
    ]

    return (
        <RootAdmin>
           <Card radius='sm' className='col-span-4 p-3'>
                <div className="w-full h-[600px] z-10">
                    <div className={'flex flex-row justify-between mb-5 items-center w-full'}>
                        <div className={'w-1/2'}>
                            <span className='text-primary text-xl font-bold'>{titlePage(tipe)}</span>
                        </div>

                        <div className={'w-1/3'}>
                            <Select
                                radius="sm"
                                label="Filter"
                                labelPlacement="outside"
                                size="md"
                                placeholder='Pilih filter'
                                value={tipe}
                                defaultSelectedKeys={[tipe]}
                                disallowEmptySelection={true}
                                onChange={(e) => {
                                    setSelectedPoint(null)
                                    setTipe(e.target.value)
                                }}
                            >
                                {filtering?.map(item => (
                                    <SelectItem key={item.value} value={item.value}>{item.name}</SelectItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                  <ReactMapGL
                    {...viewport}
                    mapboxAccessToken='pk.eyJ1Ijoic2liMy1rbGhrIiwiYSI6ImNtMms1ZWVrZjAxb3MybHEyajE5cG5zb28ifQ.aCs5cuGJhZqytwo7zlVl5w'
                    mapStyle="mapbox://styles/sib3-klhk/cm3i4eidd00dn01s9809ze69i"
                    onMove={handleViewportChange}
                    dragPan={true}
                    scrollZoom={true}
                    doubleClickZoom={true}
                    touchZoom={true}
                  >

                {Array.isArray(map?.responseData)
                        ? map.responseData.map((point, index) => koordinatSah(point?.latitude, point?.longitude) && (
                            <Marker key={index} latitude={point?.latitude} longitude={point?.longitude}>
                                <div
                                    onClick={() => {
                                        if (tipe === 'sebaran-gudang' ||
                                            tipe === 'sebaran-bahanb3' ||
                                            tipe === 'sebaran-pelabuhan-bongkar' ||
                                            tipe === 'sebaran-bahanb3-province' ||
                                            tipe === 'sebaran-bahanb3-regencies') { // these endpoints are for modal
                                            setIsModalOpen(true);
                                        }
                                        setSelectedPoint(point)
                                    }}
                                    style={{ cursor: 'pointer', fontSize: '24px' }}
                                >
                                    📍
                                </div>
                            </Marker>
                        ))
                        : null}

                    {selectedPoint && renderPopup(tipe)}
                  </ReactMapGL>
                </div>
            </Card>
            {renderModal()}
        </RootAdmin>
    );
};
export default ImportMaps;
